import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { AdvancedTechStackComponent } from '../../components/advanced-tech-stack/advanced-tech-stack.component';
import { RoiCalculatorComponent } from '../../components/roi-calculator/roi-calculator.component';
import { CiiBadgeComponent } from '../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [AdvancedTechStackComponent, RoiCalculatorComponent, CiiBadgeComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  constructor(
    private titleService: Title,
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Mesh Box : Agence de Développement Logiciel Node.js & Angular — Expert Agréé CII");
    this.metaService.updateTag({ name: 'description', content: "Expert en développement Node.js, Angular et modernisation d'applications legacy. Agence agréée CII (Crédit Impôt Innovation) offrant jusqu'à 20% de réduction fiscale sur vos projets innovants." });
  }

  scrollToRoi() {
    const element = document.getElementById('roi-calculator');
    if (!element) return;

    const headerOffset = 90; // Hauteur header + marge confort
    const elementPosition = element.getBoundingClientRect().top;
    const startPosition = window.pageYOffset;
    const offsetPosition = elementPosition + startPosition - headerOffset;

    const distance = offsetPosition - startPosition;
    const duration = 1000; // Durée de l'animation en ms (1 seconde)
    let start: number | null = null;

    // Fonction d'easing (lissage) : Ease In Out Cubic pour un démarrage et une fin en douceur
    const easeInOutCubic = (t: number, b: number, c: number, d: number) => {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t * t + b;
      t -= 2;
      return c / 2 * (t * t * t + 2) + b;
    };

    const animation = (currentTime: number) => {
      if (start === null) start = currentTime;
      const timeElapsed = currentTime - start;
      const run = easeInOutCubic(timeElapsed, startPosition, distance, duration);

      window.scrollTo(0, run);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  }
}
